import "./App.css";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import Nav from "./components/NavBar";
import Hero from "./components/Hero";
import About from "./components/About";
import Education from "./components/Education";
import Skills from "./components/Skills";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import LearningPage from "./components/LearningPage";
import FrontEndTopicPage from "./components/FrontEndTopicPage";
import BackEndTopicPage from "./components/BackEndTopicPage";
import TopicPage from "./components/TopicPage";
import Learnings from "./components/Learnings";
import LearningDetailPage from "./components/LearningDetailPage";
import Resources from "./components/Resources";
import JourneyPage from "./components/JourneyPage";
import ScrollProgress from "./components/ScrollProgress";
import PageTransition from "./components/PageTransition";
import t from "./translations";

const color = "purple";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            <PageTransition>
              <Hero color={color} />
              <About color={color} />
              <Education color={color} />
              <Skills color={color} />
              <Experience color={color} />
              <Projects color={color} />
              <Contact color={color} />
            </PageTransition>
          }
        />
        <Route
          path="/learning"
          element={
            <PageTransition>
              <LearningPage color={color} />
            </PageTransition>
          }
        />
        <Route
          path="/frontEndLearning/:slug"
          element={
            <PageTransition>
              <FrontEndTopicPage color={color} />
            </PageTransition>
          }
        />
        <Route
          path="/backEndLearning/:slug"
          element={
            <PageTransition>
              <BackEndTopicPage color={color} />
            </PageTransition>
          }
        />
        <Route
          path="/testingLearning/:slug"
          element={
            <PageTransition>
              <TopicPage
                color={color}
                topics={t.testingTopics}
                strings={t.testingTopic}
                backPath="/learning"
                tabIndex={2}
              />
            </PageTransition>
          }
        />
        <Route
          path="/mobileLearning/:slug"
          element={
            <PageTransition>
              <TopicPage
                color={color}
                topics={t.mobileTopics}
                strings={t.mobileTopic}
                backPath="/learning"
                tabIndex={3}
              />
            </PageTransition>
          }
        />
        <Route
          path="/designLearning/:slug"
          element={
            <PageTransition>
              <TopicPage
                color={color}
                topics={t.designTopics}
                strings={t.designTopic}
                backPath="/learning"
                tabIndex={4}
              />
            </PageTransition>
          }
        />
        <Route
          path="/learnings"
          element={
            <PageTransition>
              <Learnings />
            </PageTransition>
          }
        />
        <Route
          path="/learnings/:slug"
          element={
            <PageTransition>
              <LearningDetailPage color={color} />
            </PageTransition>
          }
        />
        <Route
          path="/journey"
          element={
            <PageTransition>
              <JourneyPage color={color} />
            </PageTransition>
          }
        />
        <Route
          path="/resources"
          element={
            <PageTransition>
              <Resources />
            </PageTransition>
          }
        />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ScrollProgress />
      <Nav color={color} />
      <AppRoutes />
      <Footer color={color} />
    </Router>
  );
}

export default App;
